<template>
    <div >
        <el-row :gutter="5">
            <el-col :span="3"><el-input v-model="sCustomerName" style="width:100%" placeholder="客户名称"></el-input></el-col>
            <el-col :span="3"><el-input v-model="sProName" style="width:100%" placeholder="产品名称"></el-input></el-col>
            <el-col :span="3"><el-input v-model="sProCode" style="width:100%" placeholder="商品条码"></el-input></el-col>
            <el-col :span="3">
                <el-select v-model="sInOut" placeholder="出入库" clearable filterable>
                    <el-option value="" label="全部"></el-option>
                    <el-option value="In" label="入库"></el-option>
                    <el-option value="Out" label="出库"></el-option>
                </el-select>
            </el-col>
            <el-col :span="3">
                <el-date-picker  v-model="sInputDtFrom"  type="date" style="width: 100%" placeholder="出入库日期从" width="80px"></el-date-picker>
            </el-col>
            <el-col :span="3">
                <el-date-picker  v-model="sInputDtTo"  type="date" style="width: 100%" placeholder="出入库日期到"></el-date-picker>
            </el-col>
            <el-col :span="2"><el-button type="primary" icon="el-icon-search" style="width:100%"  @click="handleRefresh" >查询</el-button></el-col>
            <el-col :span="2"><el-button type="primary" icon="el-icon-plus" style="width:100%" @click="handleAdd">新增</el-button></el-col>
            <el-col :span="2"><el-button type="primary" icon="el-icon-download" style="width:100%" @click="handleExport">导出</el-button></el-col>
        </el-row>
        <el-table :data="StoreLogs" 
            max-height="680" 
            v-loading="listLoading" 
            ref="singleTable" 
            border 
            header-cell-style="background-color: #f2f2f2;color:#707070;font-weight: normal; background-image: linear-gradient(to bottom,#f8f8f8 0,#ececec 100%);
    background-repeat: repeat-x;"
            @sort-change="changeTableSort"  >
             <el-table-column label="删除" fixed width="60">
                <template slot-scope="scope">
                    <i class="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></i>
                </template>
            </el-table-column>
            <el-table-column label="编辑" fixed width="60">
                <template slot-scope="scope">
                    <i class="el-icon-edit" @click="handleEdit(scope.$index, scope.row)"></i>
                </template>
            </el-table-column>
            <el-table-column prop="CustomerName" label="客户名称" sortable='custom'  width="120"></el-table-column>
            <el-table-column prop="ProName" label="产品名称" sortable='custom'  width="120"></el-table-column>
            <el-table-column prop="ProCode" label="商品条码" sortable='custom'  width="120"></el-table-column>
            <el-table-column prop="InOutDesc" label="出/入库"  sortable='custom' width="80" align="center"></el-table-column>
            <el-table-column prop="Count" label="数量"  width="80" align="right"></el-table-column>
            <el-table-column prop="InputDate" label="出/入库日期" sortable='custom' width="150" align="center" :formatter="formatterController"></el-table-column>
            <el-table-column prop="TotalWeight" label="重量(总计)"  width="120" align="right"></el-table-column>
            <el-table-column prop="TotalCube" label="体积(总计)"  width="120" align="right"></el-table-column>
            <el-table-column prop="Remark" label="备注"  width="200" align="left"></el-table-column>
        </el-table>
        <el-col  :span="24">
            <el-pagination small
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="recordtotal">
            </el-pagination>
        </el-col>

        <el-dialog title="编辑" :visible.sync="editFormVisible" >
            <el-form :model="editForm">
                <el-form-item label="客户" :label-width="formLabelWidth">
                    <el-select v-model="editForm.CustomerId" placeholder="客户" clearable filterable>
                        <el-option v-for="customer in customers" :key="customer.Id" :label="customer.Desc" :value="customer.Id" >{{customer.Desc}}</el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="产品" :label-width="formLabelWidth">
                    <el-select v-model="editForm.ProId" placeholder="产品" clearable filterable @change="handleProChanged">
                        <el-option v-for="production in productions" :key="production.Id" :label="production.Name" :value="production.Id" >{{production.Name}}</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数量" :label-width="formLabelWidth">
                    <el-input v-model="editForm.Count" auto-complete="off" @change="handleChangeCount"></el-input>
                </el-form-item>
                <el-form-item label="" :label-width="formLabelWidth">
                    {{ "体积：" + TotalCube  }}<br/>
                    {{ "重量：" + TotalWeight  }}
                </el-form-item>
                <el-form-item label=" " :label-width="formLabelWidth">
                    <el-radio v-model="editForm.InOut" label="Out">出库</el-radio>
                    <el-radio v-model="editForm.InOut" label="In">入库</el-radio>
                </el-form-item>
                <el-form-item label="出/入库日期" :label-width="formLabelWidth">
                    <el-date-picker v-model="editForm.InputDate" placeholder="出/入库日期"  format="yyyy-MM-dd" ></el-date-picker>
                </el-form-item>
                <el-form-item label="备注" :label-width="formLabelWidth">
                   <el-input v-model="editForm.Remark" placeholder="备注" type ="textarea" :rows=4 ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancel">取 消</el-button>
                <el-button type="primary" @click="handleUpdate">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import MaintainStoreLogJS from "./MaintainStoreLog.js";

    export default MaintainStoreLogJS;
</script>

<style >
    .el-row {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 10px;
    }
  }
  .el-table tr
  {
      height: 35px;
  }

  
</style>





// WEBPACK FOOTER //
// src/components/MaintainStoreLog/MaintainStoreLog.vue